var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from '../../decorators';
import { Platform } from '../../utils';
let StorageService = class StorageService {
    storage;
    constructor(isTemporary = false) {
        if (Platform.OS === 'web') {
            if (isTemporary) {
                this.storage = sessionStorage;
            }
            else {
                this.storage = localStorage;
            }
        }
        else {
            throw new Error('StorageService is not supported on this platform');
        }
    }
    async get(key) {
        try {
            const item = this.storage.getItem(key);
            if (item) {
                try {
                    const parsed = JSON.parse(item);
                    // Check if it's the new format with value/expires
                    if (parsed && typeof parsed === 'object' && 'value' in parsed) {
                        const { value, expires } = parsed;
                        if (expires === undefined || expires > Date.now()) {
                            return value;
                        }
                        // If the item has expired, delete it from storage
                        await this.delete(key);
                        return null;
                    }
                    // Old format or direct value - try to return as-is
                    // This handles legacy data that might have been stored directly
                    return parsed;
                }
                catch (parseError) {
                    // If JSON.parse fails, it might be legacy data stored as plain string
                    // Try to return it as-is (for backwards compatibility)
                    // But log a warning for debugging
                    console.warn(`[StorageService] Legacy storage format detected for key "${key}". Consider migrating to new format.`);
                    // For backwards compatibility, return the raw string if it's a string
                    // But this might not be correct for all cases, so we'll try to parse it first
                    // If it's not valid JSON and looks like a token (starts with "eyJ"), it's likely legacy data
                    if (typeof item === 'string' && item.startsWith('eyJ')) {
                        // This looks like a JWT token stored directly - return it
                        return item;
                    }
                    // Otherwise, re-throw the original error
                    throw parseError;
                }
            }
            return null;
        }
        catch (error) {
            throw new Error(`Failed to get value from storage: ${error}`);
        }
    }
    async set(key, value, expires) {
        try {
            const item = {
                value,
                expires: expires ? Date.now() + expires : undefined,
            };
            this.storage.setItem(key, JSON.stringify(item));
        }
        catch (error) {
            throw new Error(`Failed to set value to storage: ${error}`);
        }
    }
    async delete(key) {
        try {
            this.storage.removeItem(key);
        }
        catch (error) {
            throw new Error(`Failed to delete value from storage: ${error}`);
        }
    }
    async clear() {
        try {
            this.storage.clear();
        }
        catch (error) {
            throw new Error(`Failed to clear storage: ${error}`);
        }
    }
};
StorageService = __decorate([
    singleton,
    __metadata("design:paramtypes", [Boolean])
], StorageService);
export { StorageService };
//# sourceMappingURL=data:application/json;base64,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